// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"250":"59d1a802","7715":"507d517c","8484":"c2490085"}[chunkId] + ".chunk.css";
};